import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./primary-button.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./primary-button.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
let PrimaryButtonComponent = class PrimaryButtonComponent {
    displayText;
    clickCallBack = new EventEmitter();
    disabled;
    constructor() {
    }
    ngOnInit() {
        this.displayText = this.displayText.toLowerCase();
    }
    onclick($event) {
        this.clickCallBack.emit($event);
    }
    static ctorParameters = () => [];
    static propDecorators = {
        displayText: [{ type: Input }],
        clickCallBack: [{ type: Output }],
        disabled: [{ type: Input }]
    };
};
PrimaryButtonComponent = __decorate([
    Component({
        selector: "app-primary-button",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PrimaryButtonComponent);
export { PrimaryButtonComponent };
